export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#1A110C" />
    <rect x="14" y="26" width="10" height="26" rx="5" fill="#8C4A28" />
    <rect x="27" y="12" width="10" height="40" rx="5" fill="#E8893F" />
    <rect x="40" y="20" width="10" height="32" rx="5" fill="#C9692C" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <a href="#top" data-testid="header-logo-link" className="flex items-center gap-2 sm:gap-3 group shrink-0">
    <LogoMark className="w-8 h-8 sm:w-9 sm:h-9 transition-transform duration-500 group-hover:rotate-[-8deg]" />
    <span className={`font-serif text-base sm:text-lg leading-none tracking-tight whitespace-nowrap ${light ? "text-[#FDFBF7]" : "text-[#2A1C15]"}`}>
      Pellet <em className="italic text-[#E8893F]">Italiana</em>
    </span>
  </a>
);
